// ✅ axiosClient.js — Safe Authentication & Protected Requests Handling

import axios from "axios";

const axiosClient = axios.create({
   baseURL: process.env.REACT_APP_API_BASE,
  headers: { "Content-Type": "application/json" },
});

// ==========================================================
// Token Refresh Control
// ==========================================================
let isRefreshing = false;
let refreshSubscribers = [];

// ==========================================================
// Refresh Queue Helpers
// ==========================================================
function subscribeTokenRefresh(callback) {
    refreshSubscribers.push(callback);
}

function onRefreshed(newAccessToken) {
    refreshSubscribers.forEach(callback => callback(newAccessToken));
    refreshSubscribers = [];
}

// ✅ Attach token always if exists
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token && token !== "undefined") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Auto logout only when:
// ✅ Token exists
// ✅ Protected API request (not /auth/*)
// ✅ Real 401 Unauthorized, not OPTIONS
axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    originalRequest._retry = originalRequest._retry || false;

    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const method = error?.config?.method?.toUpperCase();
    const token = localStorage.getItem("access_token");

    const isAuthRequest = url.startsWith("/auth/");
    const isSafeMethod = ["GET", "POST", "PUT", "DELETE"].includes(method);

    if (
    token &&
    status === 401 &&
    !isAuthRequest &&
    isSafeMethod &&
    !originalRequest._retry
) {
    originalRequest._retry = true;

    // Refresh token logic 
    
    const refreshToken = localStorage.getItem("refresh_token");

    if (!refreshToken) {
        localStorage.removeItem("access_token");
        window.location.href = "/login";
        return Promise.reject(error);
    }
    // ===============================
    // Add this block here
    // ===============================
    if (isRefreshing) {
        return new Promise((resolve) => {
            subscribeTokenRefresh((newAccessToken) => {
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                resolve(axiosClient(originalRequest));
            });
        });
    }

    isRefreshing = true;

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_BASE}/auth/api/refresh`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${refreshToken}`,
                },
            }
        );

        const newAccessToken = response.data.access_token;

        localStorage.setItem("access_token", newAccessToken);

        // Update THIS failed request first
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        // Wake up all waiting requests
        onRefreshed(newAccessToken);

        // Retry the original request
        return axiosClient(originalRequest);

    } catch (refreshError) {

        // Clear waiting requests
        refreshSubscribers = [];

        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");

        window.location.href = "/login";

        return Promise.reject(refreshError);

    } finally {

        // Allow future refresh requests
        isRefreshing = false;

    }

}
    return Promise.reject(error);
  }
);

export default axiosClient;
